import CampaignAttributionDateNote from '../../shared/partials/campaign-attribution-date-note.pt.mdx';

export const title = 'Faturamento por campanha (Gráfico)';

Faturamento total gerado por vendas atribuídas a campanhas.

<CampaignAttributionDateNote />
